import * as React from "react";
const SvgFiRrRestock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-restock_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 6.617-5.383 12-12 12a12.02 12.02 0 0 1-9.996-5.37L2 20a1 1 0 1 1-2 0v-2.991C0 15.902.901 15 2.008 15H5a1 1 0 1 1 0 2H3.363c1.776 3.06 5.052 5 8.637 5 5.514 0 10-4.486 10-10a1 1 0 1 1 2 0m-1-9a1 1 0 0 0-1 1l-.004 1.355C19.807 2.04 16.107 0 12 0 5.383 0 0 5.383 0 12a1 1 0 1 0 2 0C2 6.486 6.486 2 12 2c3.64 0 6.9 1.921 8.666 5H19a1 1 0 1 0 0 2h3a2 2 0 0 0 2-2V4a1 1 0 0 0-1-1M10 17c-1.654 0-3-1.346-3-3v-4c0-1.654 1.346-3 3-3h4c1.654 0 3 1.346 3 3v4c0 1.654-1.346 3-3 3zm0-2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4c-.551 0-1 .448-1 1v4c0 .552.449 1 1 1m1.5-3h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-restock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRestock;
